import { ChangeDetectionStrategy, Component, effect, forwardRef, input, output, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputSize } from '../../../enum/input-size.enum';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-password-input',
  imports: [MatIcon],
  templateUrl: './password-input.component.html',
  styleUrl: './password-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordInputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordInputComponent implements ControlValueAccessor {
  protected readonly InputSize = InputSize;
  placeholder = input<string>('');
  autocomplete = input<string>('');
  inputMode = input<'text' | 'numeric' | 'decimal' | 'tel' | 'search' | 'email' | 'url'>('text');
  controlId = input<string | null>(null);
  error = input<boolean>(false);
  inputSize = input<InputSize>(InputSize.large);
  toggleDefaultVisibility = input<boolean>(false);
  valueChange = output<string | null>();

  public showPassword = signal<boolean>(false);
  public value = signal<string | null>(null);

  public disabled = signal(false);
  constructor() {
    effect(() => {
      if (this.toggleDefaultVisibility()) {
        this.showPassword.update(showPassword => !showPassword);
      }
    });
  }

  public writeValue(value: string | null): void {
    this.value.set(value);
  }

  public registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public handleInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value.set(inputValue);
    this.valueChange.emit(inputValue);
    this.onChange(inputValue);
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  public toggleVisibilityClicked(): void {
    this.showPassword.update(showPassword => !showPassword);
  }

  private onChange: (value: string | null) => void = () => {
    // default onChange
  };
  private onTouched: () => void = () => {
    // default onTouched
  };
}
